import styled from 'styled-components';

interface DivProps {
    error:boolean;
    height: string;
}

export const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  color: ${props => props.theme.colors.black};
  background: ${props => props.theme.colors.white};
  border: none;
  padding: 17px 20px 17px 20px;
  font-size: 16px;
  resize: none;

  @media screen and (max-width:960px){
    width: 100%;
    height: 100%;
  }
`;

export const TagError = styled.div`
  position:relative;
  z-index:20;
  padding:3px 8px 2px 8px;
  background:${props=>props.theme.colors.danger};
  font-weight:700;
  text-align:center;
  font-size:14px;
  color:${props=>props.theme.colors.white};
  width:max-content;
  border-radius:16px;
  top:-10px;
  margin:0 auto;
`;

export const Column = styled.div<DivProps>`
  width: 100%;
  height: ${props => props.height};
  border-radius: 4px;
  border:${props=>props.error ? `2px solid ${props.theme.colors.danger}` : `1.5px solid ${props.theme.colors.lightGray}` };

  @media screen and (max-width:960px){
    max-width: 320px;
    width: 100%;
    height: ${props => props.height};
  }
`;
